export default __webpack_public_path__ + "static/media/thumb-4.259c577f.png";